define('modules/media/pusher',['require','exports','module','mediaelement','app','modules/media/binder','modules/media/video','modules/media/audio','modules/media/edge','modules/alternative','modules/media/iframer'],function(require, exports, module) {"use strict";

	var Player = require("mediaelement");
	var app = require("app");

	var Binder = require("modules/media/binder");
	var Video = require("modules/media/video");
	var Audio = require("modules/media/audio");
	var Edge = require("modules/media/edge");
	var Alternate = require("modules/alternative");
	var Iframer = require("modules/media/iframer");
	//var LoaderEdge = require("animate_loader");

	module.exports = {

		set_navigator : function(i) {

			return ( function(i) {

					var old = document.querySelectorAll('#is_nav ul li.active');

					if (old.length > 0) {
						old[0].className = '';

					}

					var current = document.querySelectorAll('#is_nav ul li')[i];

					return current.setAttribute('class', 'active');

				}(i));

		},

		isforced : "",

		check_player_init : function() {

			/*window.mejs = null;
			 window.MediaElement = null;
			 window.MediaElementPlayer = null;*/

		},

		prefix : function() {
			var styles = window.getComputedStyle(document.documentElement, ''), pre = (Array.prototype.slice
			.call(styles)
			.join('')
			.match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o'])
			)[1], dom = ('WebKit|Moz|MS|O').match(new RegExp('(' + pre + ')', 'i'))[1];
			return {
				dom : dom,
				lowercase : pre,
				css : '-' + pre + '-',
				js : pre[0].toUpperCase() + pre.substr(1)
			};
		},

		breakpoint : {

			s : 600,
			m : 1024,
			l : 1280

		},

		get_orientation : function() {

			var vr = this.get_view_res();

			return (vr.w >= vr.h) ? 'land' : 'port';

		},

		get_media_res : function() {

			var w = this.get_screen_res().w;

			var r = 'small';

			if (w <= this.breakpoint.s) {

				r = 'small';

			}

			if (w > this.breakpoint.s && w <= this.breakpoint.m) {

				r = 'medium';

			}

			if (w > this.breakpoint.m && w <= this.breakpoint.l) {

				r = 'large';

			}

			if (w > this.breakpoint.l) {

				r = 'large';

			}

			return r;

		},

		get_screen_res : function() {

			return {
				w : screen.width,
				h : screen.height
			};

		},

		get_view_res : function() {
			var e = window;
			var a = 'inner';
			if (!('innerWidth' in window)) {
				a = 'client';
				e = document.documentElement || document.body;
			}
			return {
				w : e[a + 'Width'],
				h : e[a + 'Height']
			};

		},

		NametoInt : function(id) {

			var sh = this.showArrow;
			var hi = this.hideArrow;

			if (_.isUndefined(id) || (_.isNull(id))) {

				id = Backbone.history.getFragment().replace('s/', '');
			}

			return (function(id) {
				//IE is simplest and fastest
				var ele = document.getElementById(id);

				if (_.isNull(ele)) {

					return 0;
					//alert( 'elemento a cui  puntate:  ' + id  +", non esoste nella pagina");
				}

				if ("sourceIndex" in ele) {
					if (ele.sourceIndex) {
						return ele.sourceIndex - ele.parentNode.sourceIndex - 1;
					}
				}
				//other browsers
				var i = 0;
				while ( ele = ele.previousElementSibling) {
					i++;
				}

				i === 0 ? sh() : hi();

				//	//////console.log ("IIII",i)
				return i;
			})(id);

		},

		showArrow : function() {
			var arrow = document.getElementById("arrowBounce");
			arrow.className = arrow.className.replace("arrowHidden", "");
		},

		hideArrow : function() {
			var arrow = document.getElementById("arrowBounce");
			arrow.className = "arrow animated bounce arrowHidden";
		},

		hideCredits : function() {
			this.hidePopupCrediti();
			this.hidePopupInfografiche();
		},

		loader_S_H : function(act) {

			return (function() {

				var loader = document.getElementById("isloader");
				loader.className = act ? '' : "loaderHidden";

			})();

		},

		showPopupCrediti : function() {
			var elm = document.getElementById("credit_sx_block");
			elm.className += " showPopup";
		},

		hidePopupCrediti : function() {
			var elm = document.getElementById("credit_sx_block");
			elm.className = elm.className.replace("showPopup", "");
		},

		showPopupInfografiche : function() {
			var elm = document.getElementById("credit_dx_block");
			elm.className += " showPopup";
		},

		hidePopupInfografiche : function() {
			var elm = document.getElementById("credit_dx_block");
			elm.className = elm.className.replace("showPopup", "");
		},

		get_media_by_keyframe : function(key, id, direction) {

			if (!_.isUndefined(id) && !_.isNull(id)) {

				////console.log (" ID", id )

				if ("frame" in modules_cfg[id].properties) {

					this.currentFrame= id;

					var events = modules_cfg[id].properties.frame;

					if (!_.isUndefined(events[key])) {

						var el = document.getElementById(id);

						var status = "onEnter";

						if (direction === 'up') {

							status = "onLeave";

						}

						if (this.isforced === '') {

							if (events[key] === status) {

								this.set_navigator(this.NametoInt(id));

								this.get_media_by_id(el);

								////console.log ('LOAD ->', id, this.isforced, "to int", this.NametoInt(id));

								app.router.navigate("s/" + id);

							} else {

								// //console.log ('UNLOAD', id);

								this.unload_media(el);

							}

						} else {

							////console.log ('CATCHED',id , this.isforced   , events[key] , status );

							if (id === this.isforced) {

								////console.log ('VVV', id, this.isforced, events[key], status);

								if (events[key] === status) {

									this.set_navigator(this.NametoInt(this.isforced));
									this.get_media_by_id(el);

								} else {

									// //console.log ('UNLOAD 2', id);
									this.unload_media(el);

								}

								this.isforced = '';

							}

							//this.isforced = '';
							return;

		

						}

						////////console.log ('cè ', events[key], modules_cfg[id].properties.events[events[key]]);

					}
				}
			}

		},

		get_media_events : function() {

			// modules_cfg[id].properties.events[events[key]]

		},

		get_media_by_id : function(elements, Global_callback) {

			if (_.isNull(elements)) {

				elements = document.getElementById(_.keys(modules_cfg)[0]);
				//console.log(' MODULO ', ", non trovato, redirect al primo modulo");
			}

			var id = elements.id;

			var media;
			var type;
			var res = this.get_media_res();
			var ori = this.get_orientation();
			var el;

			//console.log(' MODULO ', id);

			if (!( id in modules_cfg)) {
				return;

			}

			switch (modules_cfg[id].contents.type) {
				
				
				case 'iframer':
					

					type = 'iframer';
					media = modules_cfg[id].contents;
					
					console.log('POS',_.indexOf(modules_cfg,id));

					break;
				
				

				case 'alternative':
					//todo preload?

					type = 'alternative';

					break;

				case 'animate':
					type = 'animate';
					var w = 1280;
					var h = 720;

					if ('dimension' in modules_cfg[id].properties) {

						w = Number(modules_cfg[id].properties.dimension.width);
						h = Number(modules_cfg[id].properties.dimension.height);

					}

					media = {
						id : modules_cfg[id].contents["edge-id"],
						images : modules_cfg[id].contents.images,
						w : w,
						h : h
					};
					el = {
						actions : modules_cfg[id].contents.actions,
						edge : modules_cfg[id].contents.edge,
						id : id
					};

					break;

				case 'credits':

					type = "credits";
					el = elements.querySelectorAll('.is_shim')[0];

					media = modules_cfg[id].contents.imgs.port[res];

					//	//////console.log (' OK ', ori, res,media);

					//parentNode
					break;

				case 'interview':

					type = "mixin";
					el = elements.querySelectorAll('.is_shim')[0];
					media = {
						img : modules_cfg[id].contents.imgs[ori][res],
						audio : document.getElementById(id + '_audio')
					};
					//////console.log (' OK ', ori, res, media);

					//parentNode
					break;

				case 'cover_full':

					type = "img";
					el = elements.querySelectorAll('.is_shim')[0];
					media = modules_cfg[id].contents.imgs[ori][res];

					////////console.log (' OK ', ori, res, modules_cfg[id].contents.imgs);
					break;

				case 'cover_clip':

					//TODO resize nel caso altezza non ci sta nell'area visibile.

					type = "img";
					el = elements.querySelectorAll('.is_shim')[0];

				

					if (ori === 'port') {
						ori = "land";

					}
					ori = "land";

					media = modules_cfg[id].contents.imgs[ori][res];
					////////console.log (' OK ', ori, res, modules_cfg[id].contents.imgs);
					break;

				case 'clip_video':

					//////console.log ('PLAY VIDEO')

					type = "clip";
					el = document.getElementById(id + '_clip');

					if (res === 'small') {

						res = 'medium';
					}

					media = modules_cfg[id].contents.clip[res];
					////////console.log (' OK ', ori, res, el);
					break;

			}

			return this.set_media(type, el, media, elements, Global_callback);

		},

		resizeWin : function() {

			var THRESHOLD = 550;
			var timeoutId;
			var resizing = false;
			var loader = this.loader_S_H;
			var hashnow;

			Binder.addEvent(window, "resize", function() {
				var timeout = function() {
					clearTimeout(timeoutId);

					timeoutId = setTimeout(function() {
						resizing = false;
						//////console.log ('resizeEnd');

						app.ViewType.re_Init(hashnow);

						loader(false);

						//	//////console.log ('DIFFERENTE ',   app , Backbone.history.getFragment().replace('s/','') ,hashnow);

					}, THRESHOLD);
				};

				if (!resizing) {

					app.ViewType.skrollr.off("keyframe");

					resizing = true;
					//hashnow=Backbone.history.getFragment().replace('s/','');
					loader(true);
					hashnow = Backbone.history.getFragment().replace('s/', '');
					//app.ViewType.skrollr.destroy();

					//////console.log ('resizeStart' , app.ViewType.skrollr);
				}

				timeout();
			});

			

		},

		unload_media : function(el) {

			if (_.isNull(el)) {

				var hs = Backbone.history.getFragment().replace('s/', '');

				el = document.getElementById(Backbone.history.getFragment().replace('s/', ''));

				if (_.isNull(el)) {

					return;
				}

			}

			var id = el.id;

			if (_.isUndefined(id) || (_.isNull(id))) {

				id = Backbone.history.getFragment().replace('s/', '');
			}

			if (!( id in modules_cfg)) {
				return;

			}

			switch (modules_cfg[id].contents.type) {

				case 'alternative':

					Alternate.release();

					break;

				case 'interview':

					Audio.Unbind(id);

					break;

				case 'animate':

					////////console.log ('DRW IN');

					//if (app.current_device!='mobile'){

					Edge.rewind(id, modules_cfg[id].contents["edge-id"]);

					

					break;
				case 'clip_video':

					//////console.log ('CLIP ONLOAD')

					Video.Unbind(id);

					break;

				case 'credits':

					var elmApriCrediti = document.getElementById("apri_crediti");
					var elmChiudiCrediti = document.getElementById("chiudi_crediti");

					var elmApriInfografiche = document.getElementById("apri_infografiche");
					var elmChiudiInfografiche = document.getElementById("chiudi_infografiche");

					Binder.removeEvent(elmApriCrediti, "click", this.showPopupCrediti);
					Binder.removeEvent(elmChiudiCrediti, "click", this.hidePopupCrediti);

					Binder.removeEvent(elmApriInfografiche, "click", this.showPopupInfografiche);
					Binder.removeEvent(elmChiudiInfografiche, "click", this.hidePopupInfografiche);

					this.hideCredits();

					break;

			}

		},

		fillImg : function(image) {

			var el;

			if ((image.target)) {

				el = this;

			} else {

				el = image;

			}

			var pw = el.getAttribute('data-pw');
			var ph = el.getAttribute('data-ph');

			return (function() {

				////console.log(el , image);
				//return
				//console.log(el.height, 'loaded', ph, image);
				
				el.style.width = '100%';
				el.style.height = 'auto';
				el.style.maxWidth = "none";
				el.style.maxHeight = "none";

				var mustScale = false;

				if (el.height < ph) {

					el.style.width = 'auto';
					el.style.height = 'auto';
					el.style.maxWidth = "none";
					el.style.maxHeight = "none";
					//this.style.minWidth= "inherit";
					//this.style.minHeight= "inherit";

					mustScale = true;

				}

				if (mustScale) {

					var nW = ph * (el.width / el.height);

					el.style.width = nW + 'px';
					el.style.height = ph + 'px';

					//console.log(el.width, el.height, el.width / el.height, nW);
				}

			})();

		},

		set_media : function(type, el, media, elements, Global_callback) {
			switch (type) {
				
				case 'iframer':

					

					Iframer.load(elements,media);

					break;
				
				

				case 'alternative':

					////console.log('ALTERN')

					Alternate.load(elements);

					break;

				case 'animate':

					////////console.log ('DRW IN');

					Edge.load(el, media, elements, Global_callback);

					break;

				case 'mixin':

					if (_.isUndefined(el)) {
						////////console.log ( "test!");
						return;
					}

					////////console.log ( "Audio load" );
					Audio.load(modules_cfg, type, el, media, elements);

					if (el.src != media) {

						el.src = media.img;
					}

			

					break;

				case 'credits':

					if (_.isUndefined(el)) {

						return;
					}

					if (el.src != media) {

						el.src = media;
					}

					var elmApriCrediti = document.getElementById("apri_crediti");
					var elmChiudiCrediti = document.getElementById("chiudi_crediti");

					var elmApriInfografiche = document.getElementById("apri_infografiche");
					var elmChiudiInfografiche = document.getElementById("chiudi_infografiche");

					Binder.addEvent(elmApriCrediti, "click", this.showPopupCrediti);
					Binder.addEvent(elmChiudiCrediti, "click", this.hidePopupCrediti);

					Binder.addEvent(elmApriInfografiche, "click", this.showPopupInfografiche);
					Binder.addEvent(elmChiudiInfografiche, "click", this.hidePopupInfografiche);

					break;

				case 'img':

					if (_.isUndefined(el)) {

						return;
					}
					
					

					el.setAttribute('data-pw', elements.offsetWidth);
					el.setAttribute('data-ph', elements.offsetHeight);
					
					var src_now=el.src.substring(el.src.lastIndexOf('/')+1, (el.src.length));
					var src_next=media.substring(media.lastIndexOf('/')+1, (media.length));
					
					//console.log('IMG',src_now ,  src_next);

					if (src_now != src_next) {
						
					//	console.log('IMG NEW');

						if (modules_cfg[elements.id].contents.type === 'cover_full') {

							el.onload = this.fillImg;
						
						}

						el.src = media;
					}else{
						
					//	console.log('IMG SAME' ,modules_cfg[elements.id].contents.type === 'cover_full');
						
						if (modules_cfg[elements.id].contents.type === 'cover_full') {

							this.fillImg(el);
						
						}
						
					}

					break;
				case 'clip':

					//el.play();

					//////console.log ('QUI');
					Video.load(modules_cfg, type, el, media, elements);

					break;

			}
		}
	};
});

